// Target metros for trade-by-city SEO pages (/hire/:trade/:city)
export const HIRE_CITIES = [
  { slug: 'new-york-ny', name: 'New York', state: 'New York', abbr: 'NY' },
  { slug: 'newark-nj', name: 'Newark', state: 'New Jersey', abbr: 'NJ' },
  { slug: 'jersey-city-nj', name: 'Jersey City', state: 'New Jersey', abbr: 'NJ' },
  { slug: 'los-angeles-ca', name: 'Los Angeles', state: 'California', abbr: 'CA' },
  { slug: 'chicago-il', name: 'Chicago', state: 'Illinois', abbr: 'IL' },
  { slug: 'houston-tx', name: 'Houston', state: 'Texas', abbr: 'TX' },
  { slug: 'dallas-tx', name: 'Dallas', state: 'Texas', abbr: 'TX' },
  { slug: 'phoenix-az', name: 'Phoenix', state: 'Arizona', abbr: 'AZ' },
  { slug: 'philadelphia-pa', name: 'Philadelphia', state: 'Pennsylvania', abbr: 'PA' },
  { slug: 'san-antonio-tx', name: 'San Antonio', state: 'Texas', abbr: 'TX' },
  { slug: 'san-diego-ca', name: 'San Diego', state: 'California', abbr: 'CA' },
  { slug: 'austin-tx', name: 'Austin', state: 'Texas', abbr: 'TX' },
  { slug: 'fort-worth-tx', name: 'Fort Worth', state: 'Texas', abbr: 'TX' },
  { slug: 'columbus-oh', name: 'Columbus', state: 'Ohio', abbr: 'OH' },
  { slug: 'charlotte-nc', name: 'Charlotte', state: 'North Carolina', abbr: 'NC' },
  { slug: 'miami-fl', name: 'Miami', state: 'Florida', abbr: 'FL' },
  { slug: 'atlanta-ga', name: 'Atlanta', state: 'Georgia', abbr: 'GA' },
  { slug: 'boston-ma', name: 'Boston', state: 'Massachusetts', abbr: 'MA' },
  { slug: 'denver-co', name: 'Denver', state: 'Colorado', abbr: 'CO' },
  { slug: 'seattle-wa', name: 'Seattle', state: 'Washington', abbr: 'WA' },
];

export const getCity = (slug) => HIRE_CITIES.find((c) => c.slug === slug);
